import { ColumnsType } from "antd/lib/table";
import { Link } from "react-router-dom";

function renderWithLink<T>(renderFunc: any, linkByRecordFunc: any) {
    return (value: any, record: T) => {
        const destination: string | null = linkByRecordFunc(record)
        const content = renderFunc ? renderFunc(value, record) : value
        if (destination === null || destination === undefined) {
            return <span style={{ width: "100%", display: "block" }}>{content}</span>
        }
        return <Link
            style={{ color: "unset", width: "100%", display: "block" }}
            to={destination}>{content}
        </Link>
    }
}

export function useRowAsLink<T>(columns: ColumnsType<T>, linkByRecordFunc: any) {
    return columns.map((column: any) => ({
        ...column,
        render: renderWithLink(column.render, linkByRecordFunc)
    }))
}